export enum InventoryRuleActionType {
  AssignOutcome = "assign_outcome",
  TransformProduct = "transform_product",
  ListOnChannel = "list_on_channel",
  CreateConsolidation = "create_consolidation",
  CreateFlush = "create_flush",
}
